<template>
  <div class="question">
    <div class="fs-2 question-title mb-4">{{ title }}</div>
    <div class="options">
      <div class="row">
        <button
          v-for="(option, index) in options"
          :key="index"
          class="btn btn-option fs-3 mb-3 pj-ss-btn"
          :class="{ active: index === selected }"
          @click="select(index)"
        >
          {{ option }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  options: {
    type: Object as () => Record<number, string>,
    required: true,
  },
  value: Number,
});

const emit = defineEmits(["update:value"]);

const selected = ref(props.value);

const select = (option: number) => {
  selected.value = option;
  emit("update:value", option);
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.question-title {
  color: $pj-color-green;
  font-size: 1.2rem;
}

.options button {
  margin-right: 0.5rem;
}

.btn-option {
  background-color: $pj-color-chinook;
  border-radius: 30px;
  min-height: 50px;

  &:hover {
    background-color: $pj-color-gray;
    border-color: $pj-color-gray;
    color: $pj-color-white;
  }

  &:focus {
    box-shadow: none;
  }
}

.options .btn.active {
  background-color: #007bff;
  color: #fff;
}
</style>
